export var ColorId;
(function (ColorId) {
    // Grays (Neutral scale)
    ColorId["Gray1"] = "gray1";
    ColorId["Gray2"] = "gray2";
    ColorId["Gray3"] = "gray3";
    ColorId["Gray4"] = "gray4";
    ColorId["Gray5"] = "gray5";
    ColorId["Gray6"] = "gray6";
    ColorId["Gray7"] = "gray7";
    // Primary (Brand scale)
    ColorId["Primary1"] = "primary1";
    ColorId["Primary2"] = "primary2";
    ColorId["Primary3"] = "primary3";
    ColorId["Primary4"] = "primary4";
    ColorId["Primary5"] = "primary5";
    ColorId["Primary6"] = "primary6";
    ColorId["Primary7"] = "primary7";
    // Secondary
    ColorId["Secondary1"] = "secondary1";
    ColorId["Secondary2"] = "secondary2";
    ColorId["Secondary3"] = "secondary3";
    ColorId["Secondary4"] = "secondary4";
    ColorId["Secondary5"] = "secondary5";
    ColorId["Secondary6"] = "secondary6";
    ColorId["Secondary7"] = "secondary7";
    // Tertiary
    ColorId["Tertiary1"] = "tertiary1";
    ColorId["Tertiary2"] = "tertiary2";
    ColorId["Tertiary3"] = "tertiary3";
    ColorId["Tertiary4"] = "tertiary4";
    ColorId["Tertiary5"] = "tertiary5";
    ColorId["Tertiary6"] = "tertiary6";
    ColorId["Tertiary7"] = "tertiary7";
})(ColorId || (ColorId = {}));
